import React, {useState, useCallback} from "react";
import classNames from "classnames";
import {isMobileOnly} from "react-device-detect";

import {textMap} from "../common/Localization";

import './Process.scss';

const Process = () => {

	const [processNum, setProcessNum] = useState(1);
	const onClickDot = useCallback((number) => {
		setProcessNum(number);
	}, []);
	const moveLeft = useCallback(() => {
		setProcessNum(Math.max(processNum - 1, 1));
	}, [processNum]);
	const moveRight = useCallback(() => {
		setProcessNum(Math.min(processNum + 1, 6));
	}, [processNum]);
	
	if(isMobileOnly) {
		const left = (processNum - 1) * 300 * -1;
		const style = {
			left:left + "px"
		}
		return (
			<div id="process" className="view_section">
				<div className="process_wrap">
					<div className={classNames("title", "c_03")}>{textMap.formatString(textMap.process_title, <span className="c_blue">{textMap.process_title_2}</span>)}</div>				
					<div className="process_list_wrap">						
						<div className="process_drag_wrap" style={style}>
							<div className={classNames("process_item")}>
								<div className="image_wrap">
									<div className={classNames("process_num", "c_eb")}>1</div>
									<img src={process.env.PUBLIC_URL + "/icon/process_1.png"} alt=""/>
								</div>
								<div className={classNames("process_title", "c_28")}>{textMap.process_item_title_1}</div>
								<div className={classNames("process_desc", "c_69")}>{textMap.process_item_desc_1}</div>
							</div>
							<div className={classNames("process_item")}>
								<div className="image_wrap">
									<div className={classNames("process_num", "c_eb")}>2</div>
									<img src={process.env.PUBLIC_URL + "/icon/process_2.png"} alt=""/>
								</div>
								<div className={classNames("process_title", "c_28")}>{textMap.process_item_title_2}</div>
								<div className={classNames("process_desc", "c_69")}>{textMap.process_item_desc_2}</div>
							</div>
							<div className={classNames("process_item")}>
								<div className="image_wrap">
									<div className={classNames("process_num", "c_eb")}>3</div>
									<img src={process.env.PUBLIC_URL + "/icon/process_3.png"} alt=""/>
								</div>
								<div className={classNames("process_title", "c_28")}>{textMap.process_item_title_3}</div>
								<div className={classNames("process_desc", "c_69")}>{textMap.process_item_desc_3}</div>
							</div>
							<div className={classNames("process_item")}>
								<div className="image_wrap">
									<div className={classNames("process_num", "c_eb")}>4</div>
									<img src={process.env.PUBLIC_URL + "/icon/process_4.png"} alt=""/>
								</div>
								<div className={classNames("process_title", "c_28")}>{textMap.process_item_title_4}</div>
								<div className={classNames("process_desc", "c_69")}>{textMap.process_item_desc_4}</div>
							</div>
							<div className={classNames("process_item")}>
								<div className="image_wrap">
									<div className={classNames("process_num", "c_eb")}>5</div>
									<img src={process.env.PUBLIC_URL + "/icon/process_5.png"} alt=""/>
								</div>
								<div className={classNames("process_title", "c_28")}>{textMap.process_item_title_5}</div>
								<div className={classNames("process_desc", "c_69")}>{textMap.process_item_desc_5}</div>
							</div>
							<div className={classNames("process_item")}>
								<div className="image_wrap">
									<div className={classNames("process_num", "c_eb")}>6</div>
									<img src={process.env.PUBLIC_URL + "/icon/process_6.png"} alt=""/>
								</div>
								<div className={classNames("process_title", "c_28")}>{textMap.process_item_title_6}</div>
								<div className={classNames("process_desc", "c_69")}>{textMap.process_item_desc_6}</div>
							</div>
						</div>
						<div className={classNames("left_button", "cbc_4a", processNum === 1 ? "hide" : "")} onClick={moveLeft}><img src={process.env.PUBLIC_URL + "/icon/arrow_left.png"} alt=""/></div>
						<div className={classNames("right_button", "cbc_4a", processNum === 6 ? "hide" : "")} onClick={moveRight}><img src={process.env.PUBLIC_URL + "/icon/arrow_right.png"} alt=""/></div>
					</div>
					<div className="process_dot_wrap">
						<span className={classNames("process_dot")} onClick={() => onClickDot(1)}><span className={classNames("dot", processNum === 1 ? "cbc_blue" : "cbc_ce")}></span></span>
						<span className={classNames("process_dot")} onClick={() => onClickDot(2)}><span className={classNames("dot", processNum === 2 ? "cbc_blue" : "cbc_ce")}></span></span>
						<span className={classNames("process_dot")} onClick={() => onClickDot(3)}><span className={classNames("dot", processNum === 3 ? "cbc_blue" : "cbc_ce")}></span></span>
						<span className={classNames("process_dot")} onClick={() => onClickDot(4)}><span className={classNames("dot", processNum === 4 ? "cbc_blue" : "cbc_ce")}></span></span>
						<span className={classNames("process_dot")} onClick={() => onClickDot(5)}><span className={classNames("dot", processNum === 5 ? "cbc_blue" : "cbc_ce")}></span></span>
						<span className={classNames("process_dot")} onClick={() => onClickDot(6)}><span className={classNames("dot", processNum === 6 ? "cbc_blue" : "cbc_ce")}></span></span>
					</div>
				</div>
				<div className={classNames("process_footer", "bc_light_blue")}>
					<div className={classNames("arc", "bc_ff")}></div>
				</div>
			</div>
		);
	} else {
		return (
			<div id="process" className="view_section">
				<div className="process_wrap">
					<div className={classNames("title", "c_03")}>{textMap.formatString(textMap.process_title, <span className="c_blue">{textMap.process_title_2}</span>)}</div>				
					<div className="process_list_wrap">
						<div className={classNames("process_item")}>
							<div className="image_wrap">
								<div className={classNames("process_num", "c_eb")}>1</div>
								<img src={process.env.PUBLIC_URL + "/icon/process_1.png"} alt=""/>
							</div>
							<div className={classNames("process_title", "c_28")}>{textMap.process_item_title_1}</div>
							<div className={classNames("process_desc", "c_69")}>{textMap.process_item_desc_1}</div>
						</div>
						<div className={classNames("process_item")}>
							<div className="image_wrap">
								<div className={classNames("process_num", "c_eb")}>2</div>
								<img src={process.env.PUBLIC_URL + "/icon/process_2.png"} alt=""/>
							</div>
							<div className={classNames("process_title", "c_28")}>{textMap.process_item_title_2}</div>
							<div className={classNames("process_desc", "c_69")}>{textMap.process_item_desc_2}</div>
						</div>
						<div className={classNames("process_item")}>
							<div className="image_wrap">
								<div className={classNames("process_num", "c_eb")}>3</div>
								<img src={process.env.PUBLIC_URL + "/icon/process_3.png"} alt=""/>
							</div>
							<div className={classNames("process_title", "c_28")}>{textMap.process_item_title_3}</div>
							<div className={classNames("process_desc", "c_69")}>{textMap.process_item_desc_3}</div>
						</div>
						<div className={classNames("process_item")}>
							<div className="image_wrap">
								<div className={classNames("process_num", "c_eb")}>4</div>
								<img src={process.env.PUBLIC_URL + "/icon/process_4.png"} alt=""/>
							</div>
							<div className={classNames("process_title", "c_28")}>{textMap.process_item_title_4}</div>
							<div className={classNames("process_desc", "c_69")}>{textMap.process_item_desc_4}</div>
						</div>
						<div className={classNames("process_item")}>
							<div className="image_wrap">
								<div className={classNames("process_num", "c_eb")}>5</div>
								<img src={process.env.PUBLIC_URL + "/icon/process_5.png"} alt=""/>
							</div>
							<div className={classNames("process_title", "c_28")}>{textMap.process_item_title_5}</div>
							<div className={classNames("process_desc", "c_69")}>{textMap.process_item_desc_5}</div>
						</div>
						<div className={classNames("process_item")}>
							<div className="image_wrap">
								<div className={classNames("process_num", "c_eb")}>6</div>
								<img src={process.env.PUBLIC_URL + "/icon/process_6.png"} alt=""/>
							</div>
							<div className={classNames("process_title", "c_28")}>{textMap.process_item_title_6}</div>
							<div className={classNames("process_desc", "c_69")}>{textMap.process_item_desc_6}</div>
						</div>
					</div>
				</div>
				<div className={classNames("process_footer", "bc_light_blue")}>
					<div className={classNames("arc", "bc_ff")}></div>
				</div>
			</div>
		);
	}	
};

export default Process;
